import Leads from "../pages/Leads/Leads";
import SingleBookingForm from "../forms/SingleBookingForm/SingleBookingForm";
import BulkBookingForm from "../forms/BulkBookingForm/BulkBookingForm";

const SalesRoutes = [
  {
    path: "sales",
    children: [
      { path: "leads", element: <Leads initialTab="overview" /> },
      // { path: "booking", element: <Leads initialTab="booking" /> },
      { path: "leads/generate-link", element: <SingleBookingForm /> }, 
      { path: "leads/bulk-booking", element: <BulkBookingForm /> },
    ],
  },
];

export default SalesRoutes;   